export const AUTH_PATH = '/auth';
export const LOGIN_PATH = AUTH_PATH + '/login';
export const REFRESH_PATH = AUTH_PATH + '/refresh';

export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'access_token';
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'refresh_token';
export const LOCAL_STORAGE_FINANCIAL_USER_ID_KEY = 'financial_user_id';
export const LOCAL_STORAGE_USER_ID_KEY = 'user_id';